import React from 'react';
import styled from 'styled-components';
import {
    EuiButton,
    EuiModal,
    EuiModalBody,
    EuiModalFooter,
    EuiModalHeader,
    EuiModalHeaderTitle
} from '@elastic/eui';

const WhatsNewContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const GithubWarningCard = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 12px;
  background: rgba(248, 107, 99, 0.06);
  border: 1px solid rgba(248, 107, 99, 0.35);
  border-left: 4px solid #F86B63;
  padding: 12px 16px;
  border-radius: 6px;
  margin-bottom: 10px;

  p {
    margin: 0;
    font-size: 13px;
    line-height: 1.5;
    color: rgba(255, 255, 255, 0.9);
  }

  a {
    color: #66d9ef;
    font-weight: 700;
    text-decoration: underline;
    
    &:hover {
      color: #a3ebff;
    }
  }
`;

const SectionStyled = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;

  h3 {
    font-size: 14px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    color: #36A2EF;
    margin: 0;
    display: flex;
    align-items: center;
    gap: 6px;
  }

  ul {
    list-style: none;
    padding: 0;
    margin: 0;
    display: flex;
    flex-direction: column;
    gap: 6px;
  }

  li {
    font-size: 13px;
    color: rgba(255, 255, 255, 0.75);
    line-height: 1.45;
    position: relative;
    padding-left: 14px;

    &::before {
      content: "•";
      color: rgba(255, 255, 255, 0.3);
      font-size: 16px;
      position: absolute;
      left: 0;
      top: -2px;
    }
  }
`;

const WhatsNewModal = ({ close }) => {
    return (
        <EuiModal onClose={ close } style={{ maxWidth: '640px', width: '100%' }}>
            <EuiModalHeader>
                <EuiModalHeaderTitle>
                    <h2 style={{ fontSize: '20px', fontWeight: '800', margin: 0, color: 'rgba(255, 255, 255, 0.94)' }}>
                        What's New in SyAgent
                    </h2>
                </EuiModalHeaderTitle>
            </EuiModalHeader>

            <EuiModalBody>
                <WhatsNewContainer>
                    <GithubWarningCard>
                        <p>
                            We've introduced significant improvements! If you run into any bugs or issues, please let us know by creating a bug report on the <a href="https://github.com/syagent/agent-2/issues" target="_blank" rel="noreferrer">SyAgent Issues Page on GitHub</a>.
                        </p>
                    </GithubWarningCard>

                    <SectionStyled>
                        <h3>
                            UI Redesign
                        </h3>
                        <ul>
                            <li><strong>Dashboard Widgets</strong>: Upgraded resource limits, usage progress bars, and alarms summaries with modern responsive layouts and top border accents.</li>
                            <li><strong>Active Alarms Timeline</strong>: Restructured log views into clean cards featuring left-border severity status markers, server tag chips, and micro-hover translations.</li>
                            <li><strong>Settings Refactoring</strong>: Redesigned layout menus, left-accent tab transitions, constrained width forms, and structured danger zone cards.</li>
                            <li><strong>App Header & Search</strong>: Modernized logos, Beta badges, capsule dropdown profiles, search inputs, and glassmorphic dropdown search panels.</li>
                        </ul>
                    </SectionStyled>

                    <SectionStyled>
                        <h3>
                            Backend Updates
                        </h3>
                        <ul>
                            <li><strong>High Performance</strong>: All services were reWritten in GO</li>
                        </ul>
                    </SectionStyled>

                    <SectionStyled>
                        <h3>
                            Infra & DB Optimizations
                        </h3>
                        <ul>
                            <li><strong>Metrics Scaling</strong>: Enhanced DB query indexes for quick aggregation of server CPU, RAM, disk, and network stats.</li>
                        </ul>
                    </SectionStyled>
                </WhatsNewContainer>
            </EuiModalBody>

            <EuiModalFooter>
                <EuiButton onClick={ close } fill>
                    Got it, Thanks!
                </EuiButton>
            </EuiModalFooter>
        </EuiModal>
    );
};

export default WhatsNewModal;
